import { CustomRedirectOptions } from '~/apps/routes/RoutesTypes'
import {
    ADMIN_PATH,
    LOGIN_PATH,
    MFG_PARTNER_PATH,
    OPS_QUALITY_PATH,
    QUOTES_PATH,
    SIGN_IN_PATH,
} from '~/redux-modules/preferences'

/**
 * List of redirect configs
 */
export const redirects: CustomRedirectOptions[] = [
    {
        path: [
            '/parts',
            '/parts/:id',
            '/pages/projects/uncategorized',
            '/pages/projects',
            '/pages/revisions/:revisionId/viewer',
            '/pages/revisions/:revisionId/viewer/:sidebarId',
        ],
        redirectTo: '/pages/quotes',
    },
    {
        path: ['/pages/projects/:id', '/pages/projects/:id/:tab'],
        redirectTo: '/pages/quotes/:id',
        redirectWithParams: true,
    },
    {
        path: '/pages/projects/:id/accept-invite',
        redirectTo: '/pages/quotes/:id/accept-invite',
        redirectWithParams: true,
    },
    {
        path: '/pages/projects/:id/accept-open-invite',
        redirectTo: '/pages/quotes/:id/accept-open-invite',
        redirectWithParams: true,
    },
    {
        path: [
            '/pages/projects/:id/welcome/:step',
            '/pages/projects/new',
            '/pages/projects/new/:id',
        ],
        redirectTo: '/pages/quotes/new/w/name',
    },
    {
        path: [
            SIGN_IN_PATH,
            '/users/sign-in',
            '/users/signin',
            '/user/sign_in',
            '/user/sign-in',
            '/user/signin',
            '/sign_in',
            '/sign-in',
            '/signin',
        ],
        redirectTo: LOGIN_PATH,
    },
    {
        path: [
            '/users/sign_up',
            '/users/sign-up',
            '/users/signup',
            '/user/sign_up',
            '/user/sign-up',
            '/user/signup',
            '/sign_up',
            '/sign-up',
        ],
        redirectTo: '/signup',
    },
    {
        path: '/pages/quotes/new',
        redirectTo: '/pages/quotes/upload',
    },
    {
        path: '/pages/quotes/new-injection-molding',
        redirectTo: '/pages/quotes/upload?process=im',
    },
    {
        path: '/vendor/jobs/:name',
        redirectTo: '/workbench/jobs/:name',
    },
    {
        path: '/vendor/jobs',
        redirectTo: '/workbench/',
    },
    {
        path: `${ADMIN_PATH}/operations`,
        redirectTo: `${ADMIN_PATH}/operations/production/salesOrders`,
    },
    {
        path: `${ADMIN_PATH}/quote-model-revisions`,
        redirectTo: '/admin/quote-model-revisions',
    },
    {
        path: [
            `${ADMIN_PATH}/quote-model-revisions/:id`,
            '/admin/quote-model-revisions/:id/viewer',
        ],
        redirectTo: '/admin/quote-model-revisions/:id',
        redirectWithParams: true,
    },
    {
        path: '/admin/quotes/:id/w/:step',
        redirectTo: '/admin/quotes/:id',
        redirectWithParams: true,
    },
    {
        path: `${OPS_QUALITY_PATH}/:jobRequestId/`,
        redirectTo: `${OPS_QUALITY_PATH}/:jobRequestId/parts`,
        redirectWithParams: true,
    },
    {
        path: `${QUOTES_PATH}/:id/part/:revisionId/part-dfm-report`,
        redirectTo: `${QUOTES_PATH}/:id/part/:revisionId/feedback`,
        redirectWithParams: true,
    },
    {
        path: `${MFG_PARTNER_PATH}/:mfgPartnerId/`,
        redirectTo: `${MFG_PARTNER_PATH}/:mfgPartnerId/jobs`,
        redirectWithParams: true,
    },
    {
        path: `${MFG_PARTNER_PATH}/:mfgPartnerId/performance/:performanceDetailId`,
        redirectTo: `${MFG_PARTNER_PATH}/:mfgPartnerId/performance/:performanceDetailId/jobRequests`,
        redirectWithParams: true,
    },
]
